"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var HeartFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16,5 C18.7614237,5 21,7.23857625 21,10 C21,11.6372406 20.2130796,13.0906861 18.9968302,14.0027451 L12,20 L5,14.0041055 C3.78692036,13.0906861 3,11.6372406 3,10 C3,7.23857625 5.23857625,5 8,5 C9.63559896,5 11.0877712,5.7853431 12,6.99951255 C12.9122288,5.7853431 14.364401,5 16,5 Z" })));
};
HeartFilled.displayName = 'HeartFilled';
exports.default = HeartFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HeartFilled.js.map